import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import Branch from "./Branch";
import clubStore from "../../../storage/ClubStore";

const NewBranch = () => {
    useEffect(() => {
        clubStore.resetBranch();
    }, [])
  return (
    <Branch/>
  );
};

export default observer(NewBranch);